import { createApplicationHooks } from '@/modules/service-requests/shared/application-hooks';
import {
  cancelMetlifeApplication,
  changeMetlifeStatus,
  metlifeApi,
  submitMetlifeApplication,
} from '../services/metlife.service';
import { takenTypes } from '../utils/metlife-rules';
import { MetlifeApplication, MetlifeApplicationType } from '../types/metlife.types';

const hooks = createApplicationHooks<MetlifeApplication>({
  key: 'metlife',
  api: metlifeApi,
  withdrawWorkflow: 'METLIFE_APPLICATION_WITHDRAW',
});

export const useMetlifeApplications = hooks.useApplications;
export const useMetlifeApplication = hooks.useApplication;
export const useWithdrawMetlife = hooks.useWithdrawApplication;

export const useSubmitMetlife = () =>
  hooks.useApplicationMutation(submitMetlifeApplication, 'REQUEST_SUBMITTED');

export const useChangeMetlifeStatus = () =>
  hooks.useApplicationMutation(changeMetlifeStatus, 'REQUEST_UPDATED');

export const useCancelMetlife = () =>
  hooks.useApplicationMutation(cancelMetlifeApplication, 'REQUEST_UPDATED');

/**
 * The application types `ownerId` can no longer pick (one live application per type). The owner is
 * the applicant: the signed-in employee, or the applicant whose application a reviewer edits.
 */
export const useTakenMetlifeTypes = (ownerId: string, excludeType?: MetlifeApplicationType) => {
  const { data, isLoading } = hooks.useApplications(
    { pageNo: 1, pageSize: 50, filter: { UserId: ownerId } },
    Boolean(ownerId)
  );
  // Until it answers every type looks free, so the picker waits for it.
  return { taken: takenTypes(data?.items ?? [], excludeType), isLoading };
};
